import { render, staticRenderFns } from "./EventTypeDisplay.vue?vue&type=template&id=1dfaf66e&scoped=true"
import script from "./EventTypeDisplay.vue?vue&type=script&lang=js"
export * from "./EventTypeDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfaf66e",
  null
  
)

export default component.exports